<template>
  <div>
    <el-dialog
      :title="detailTitle"
      :visible.sync="CUFlag"
      :close-on-click-modal="false"
      destroy-on-close
      @close="close"
      width="560px"
    >
      <div class="block">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size"
            :timestamp="
              activity.auditDate == null
                ? ''
                : activity.auditDate + '\u3000' + activity.auditContent
            "
          >
            {{ activity.auditUserName }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { auditHistoryList } from "@/api/moveAudit";
import Bus from "./Bus.js";

export default {
  data() {
    return {
      activities: [],
      detailTitle: "调动审核详情",
      CUFlag: false
    };
  },
  methods: {
    // 获取审核列表
    getAuditHistoryList(uuid) {
      auditHistoryList(uuid).then(res => {
        if (res.code === 0) {
          let dataArray = res.data;
          if (dataArray != null && dataArray.length > 0) {
            for (let i = 0; i < dataArray.length; i++) {
              if (
                i !== dataArray.length - 1 ||
                (i === dataArray.length - 1 &&
                  dataArray[i].auditSchedule != null)
              ) {
                dataArray[i].icon = "el-icon-success";
                dataArray[i].color = "#3A85FF";
              }
              dataArray[i].size = "large";
            }
            this.activities = dataArray;
            this.uuid = this.activities[this.activities.length - 1].uuid;
          }
        }
      });
    },
    // 关闭
    close() {
      this.activities = [];
    }
  },
  created() {
    let _this = this;
    Bus.$on("details", function(item) {
      _this.CUFlag = true;
      _this.getAuditHistoryList(item.uuid);
    });
  },
  beforeDestroy() {
    Bus.$off("details");
  }
};
</script>
